const k = ({
  getAvailableHours: a,
  getAvailableMinutes: r,
  getAvailableSeconds: h
}) => {
  const m = (o, t, d, s) => {
    const c = {
      hour: a,
      minute: r,
      second: h
    };
    let n = o;
    return ["hour", "minute", "second"].forEach((i) => {
      if (c[i]) {
        let e;
        const l = c[i];
        switch (i) {
          case "minute": {
            e = l(
              n.hour(),
              t,
              s
            );
            break;
          }
          case "second": {
            e = l(
              n.hour(),
              n.minute(),
              t,
              s
            );
            break;
          }
          default: {
            e = l(
              t,
              s
            );
            break;
          }
        }
        if (e?.length && !e.includes(n[i]())) {
          const b = d ? 0 : e.length - 1;
          n = n[i](e[b]);
        }
      }
    }), n;
  }, u = {};
  return {
    timePickerOptions: u,
    getAvailableTime: m,
    onSetOption: ([o, t]) => {
      u[o] = t;
    }
  };
};
export {
  k as useTimePanel
};
